<template>
  <v-layout row justify-center align-start v-resize="getDimensions">
    <v-flex>
      <div
        style="position: absolute; visibility: hidden"
        class="qrcode"
        ref="qrCodeUrl"
      ></div>
      <v-card :height="height - 57">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-spacer></v-spacer>
          <div v-if="!showSearchRecibo">
            <v-row>
              <v-col cols="8" sm="8" md="8">
                <v-dialog
                  ref="dialogFecha"
                  v-model="modalFechaInicial"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      required
                      color="icons"
                      ref="fechaInicial"
                      outlined
                      type="date"
                      readonly
                      dense
                      v-model="fechaInicial"
                      @click="modalFecha = true"
                      label="Ver recibos desde"
                      hide-details
                      prepend-icon="fa-solid fa-calendar-days"
                      append-icon="fa-solid fa-chevron-down"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaInicial" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="cancelFechaInicial">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="setFechaInicial(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      large
                      @click="showSearchRecibo = !showSearchRecibo"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>
                        {{ showSearchRecibo ? "search_off" : "search" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    showSearchRecibo
                      ? "Ocultar filtros de búsqueda"
                      : "Mostrar filtros de búsqueda"
                  }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      large
                      @click="mostrarRendicion"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      :loading="loadButton"
                    >
                      <v-icon dark> fa-solid fa-sack-dollar </v-icon>
                    </v-btn>
                  </template>
                  <span>Generar rendicion</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </div>

          <div v-if="showSearchRecibo">
            <v-text-field
              color="icons"
              outlined
              dense
              v-model="searchRecibo"
              @click:append="showSearchRecibo = !showSearchRecibo"
              label="Búsqueda de Recibos"
              hide-details
              append-icon="fa-solid fa-xmark"
              prepend-icon="search"
              hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
            ></v-text-field>
          </div>
          <div v-else></div>
        </v-app-bar>
        <v-progress-linear
          :active="loadRecibo"
          :indeterminate="loadRecibo"
          absolute
          bottom
          color="primary"
        ></v-progress-linear>

        <v-sheet
          class="overflow-y-auto"
          :max-height="isMobile ? height - 120 : height - 120"
        >
          <v-card class="mx-auto" :max-width="width">
            <v-list v-if="loadRecibo">
              <v-skeleton-loader
                v-for="n in 7"
                :key="n"
                type="list-item-avatar-three-line"
              />
            </v-list>
            <v-list two-line v-else>
              <v-list-item-group
                v-if="dtRecibo.length === 0"
                class="ml-5 primary--text"
                >No se encontraron recibos</v-list-item-group
              >
              <v-list-group
                v-for="item in filtrarDtRecibo"
                :key="item.id"
                :value="item.codigo === 'SIN RENDIR' ? true : false"
              >
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-title>
                      <div class="primary--text font-weight-bold">
                        {{ item.codigo }}
                      </div>
                      <div>{{ $formatoFechaHoras(item.fecha) }}</div>
                    </v-list-item-title>

                    <v-list-item-action>
                      <v-list-item-action-text :class="'font-weight-bold'">
                        {{ $formatoNumero(item.total_efectivo) }}
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>
                </template>

                <v-list-item
                  v-for="child in item.recibos"
                  :key="child.id"
                  
                  v-model="selectedRecibo"
                  active-class="blue--text"
                  ><v-list-item-avatar>
                    <v-icon :color="child.fotoRecibo ? 'success' : 'warning'">
                      {{
                        child.fotoRecibo
                          ? "fa-solid fa-circle-check"
                          : "fa-solid fa-circle-exclamation"
                      }}
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content @click="editRecibo(child)">
                    <v-list-item-title class="font-weight-bold">
                      Recibo N° {{ child.numeroRecibo }}
                    </v-list-item-title>

                    <v-list-item-subtitle class="text--primary">
                      {{
                        "(" +
                        child.clienteCodigo +
                        ")" +
                        child.clienteDescripcion
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="text--primary">
                      {{ $formatoFechaHoras(child.fecha) }}
                    </v-list-item-subtitle>

                    <v-list-item-subtitle class="caption">
                      {{ child.descripcion }}
                    </v-list-item-subtitle>
                    <v-list-item-action-text
                      :class="
                        child.estado === 'B' ? 'error--text' : 'black--text'
                      "
                    >
                      Estado:
                      {{
                        child.estado === "A"
                          ? "Creado"
                          : child.estado === "C"
                          ? "Respaldado"
                          : child.estado === "P"
                          ? "Por Rendir"
                          : child.estado === "B"
                          ? "Anulado"
                          : child.estado === "F"
                          ? "Rechazado"
                          : child.estado === "R"
                          ? "Rendido"
                          : child.estado === "V"
                          ? "Verificado"
                          : child.estado === "AA"
                          ? "Anulado SAC"
                          : child.estado === "E"
                          ? "Procesado con Error SAC"
                          : child.estado === "I"
                          ? "Importado SAC"
                          : child.estado === "J"
                          ? "Para aprobar SAC"
                          : child.estado === "N"
                          ? "Importando SAC"
                          : child.estado === "O"
                          ? "Aprobado NETORDER"
                          : child.estado === "PP"
                          ? "Procesado Ok SAC"
                          : child.estado === "RR"
                          ? "Registrado SAC"
                          : child.estado === "U"
                          ? "Importado en SAC"
                          : "No definido"
                      }}
                    </v-list-item-action-text>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text :class="'font-weight-bold'">
                      Doc:{{
                        child.moneda +
                        " " +
                        $formatoNumero(child.totalDocumento)
                      }}
                    </v-list-item-action-text>
                    <v-list-item-action-text>
                      Val:{{
                        child.moneda + " " + $formatoNumero(child.totalValor)
                      }}
                    </v-list-item-action-text>

                    <v-list-item-action-text>
                      Ajuste:{{
                        child.moneda + " " + $formatoNumero(child.totalAjuste)
                      }}
                    </v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-card>
        </v-sheet>
      </v-card>

      <v-dialog
        v-model="dialogBeta"
        persistent
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card
              ref="form"
              id="lateral"
              :height="isMobile ? height : height - 100"
            >              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                {{ itemRecibo.clienteDescripcion }}
              </v-system-bar>
              <v-app-bar color="white" elevate-on-scroll flat>
                <div class="headline">Recibo N° {{ itemRecibo.numeroRecibo }}</div>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      large
                      :disabled="itemRecibo.estado === 'B'"
                      @click="generarReciboPDF()"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> fa-solid fa-print </v-icon>
                    </v-btn>
                  </template>
                  <span>Imprimir Recibo</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeRecibo"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar</span>
                </v-tooltip>
              </v-app-bar>

              <v-system-bar color="white" lights-out>
                <v-icon> fa-solid fa-calendar </v-icon>
                {{ $formatoFechaHoras(itemRecibo.fecha) }}
              </v-system-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <div>                    <v-tooltip
                      bottom
                      v-if="
                        !(
                          itemRecibo.fotoRecibo === null ||
                          itemRecibo.fotoRecibo === undefined ||
                          itemRecibo.fotoRecibo === ''
                        )
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <viewer>
                          <img
                            :src="itemRecibo.fotoRecibo"
                            class="image"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </viewer>
                      </template>
                      <span>{{
                        itemRecibo.fotoRecibo === null ||
                        itemRecibo.fotoRecibo === undefined ||
                        itemRecibo.fotoRecibo === ""
                          ? "Cargar Imagen"
                          : "Ver Imagen"
                      }}</span>
                    </v-tooltip>
                    <v-btn
                      @click="mostrarDialogCarga('Recibo')"
                      small
                      color="primary"
                      v-if="itemRecibo.estado === 'A' || itemRecibo.estado === 'C'"
                      >{{
                        itemRecibo.fotoRecibo === null ||
                        itemRecibo.fotoRecibo === undefined ||
                        itemRecibo.fotoRecibo === ""
                          ? "Cargar Foto"
                          : "Reemplazar Foto"
                      }}</v-btn
                    >
                  </div>                  <div
                    v-if="
                      !(
                        itemRecibo.fotoEfectivo === null ||
                        itemRecibo.fotoEfectivo === undefined ||
                        itemRecibo.fotoEfectivo === ''
                      )
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <viewer>
                          <img
                            :src="itemRecibo.fotoEfectivo"
                            class="image"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </viewer>
                      </template>
                      <span>{{
                        itemRecibo.fotoEfectivo === null ||
                        itemRecibo.fotoEfectivo === undefined ||
                        itemRecibo.fotoEfectivo === ""
                          ? "Cargar Imagen"
                          : "Ver foto la rendición"
                      }}</span>
                    </v-tooltip>
                  </div>

                  <v-list two-line>
                    <v-divider></v-divider>

                    <v-system-bar color="white">
                      <h3 class="primary--text">Documentos</h3>
                      <v-spacer></v-spacer>
                      Total {{ itemRecibo.moneda + " " + $formatoNumero(itemRecibo.totalDocumento) }}
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list-item-group
                      v-model="selectedDocumento"
                      active-class="blue--text"
                    >
                      <template>
                        <v-list-item v-for="item in dtDocumento" :key="item.id">
                          <template v-slot:default="{ active }">
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >{{ item.codigo + " " + item.comproTipo }}
                              </v-list-item-title>

                              <v-list-item-subtitle class="primary--text"
                                >{{ item.sucurNombre }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                >FE: {{ $formatoFechaSpanish(item.fecha) }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                :class="
                                  estaVencido(item.venciFecha)
                                    ? 'error--text'
                                    : 'success--text'
                                "
                                >FV:
                                {{ $formatoFechaSpanish(item.venciFecha) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                Importe:
                                {{
                                  item.moneda +
                                  "" +
                                  $formatoNumero(item.importe)
                                }}
                              </v-list-item-action-text>
                              <v-list-item-action-text
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                Saldo:
                                {{
                                  item.moneda + "" + $formatoNumero(item.saldo)
                                }}
                              </v-list-item-action-text>

                              <v-list-item-action-text>
                                Subtotal:
                                {{
                                  item.moneda +
                                  "" +
                                  $formatoNumero(item.subtotal)
                                }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>

                  <v-list two-line>
                    <v-divider></v-divider>
                    <v-system-bar color="white">
                      <h3 class="primary--text">Valores</h3>
                      <v-spacer></v-spacer>
                      Total {{ itemRecibo.moneda + " " + $formatoNumero(itemRecibo.totalValor) }}
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list-item-group
                      v-model="selectedValor"
                      active-class="blue--text"
                    >
                      <template>
                        <v-list-item v-for="item in dtValor" :key="item.id">
                          <template v-slot:default="{ active }">
                            <v-list-item-avatar
                              v-if="
                                !($esNulo(item.fotoComprobante) )
                              "
                            >
                              <div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <viewer>
                                      <img
                                        :src="item.fotoComprobante"
                                        class="image"
                                        v-bind="attrs"
                                        v-on="on"
                                      />
                                    </viewer>
                                  </template>
                                  <span>{{ $esNulo(item.fotoComprobante)
                                      ? "nada"
                                      : "Ver comprobante"
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                {{ item.valor }}
                              </v-list-item-title>

                              <v-list-item-subtitle class="text--primary">
                                {{ $formatoFechaSpanish(item.fecha) }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="text--primary">
                                {{ item.banco }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                class="text--primary"
                                v-if="
                                  !($esNulo(item.fotoDeposito))
                                "
                              >
                                {{
                                  item.moneda + "" + $formatoNumero(item.monto)
                                }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                v-if="
                                  $esNulo(item.fotoDeposito)
                                "
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                {{
                                  item.moneda + "" + $formatoNumero(item.monto)
                                }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                            <v-list-item-avatar
                              v-if="
                                !($esNulo(item.fotoDeposito))
                              "
                            >
                              <div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <viewer>
                                      <img
                                        :src="item.fotoDeposito"
                                        class="image"
                                        v-bind="attrs"
                                        v-on="on"
                                      />
                                    </viewer>
                                  </template>
                                  <span>{{
                                    $esNulo(item.fotoDeposito)
                                      ? "nada"
                                      : "Ver depósito dell valor"
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-avatar>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>

                  <v-divider></v-divider>
                  <v-system-bar color="white">
                    <h3 class="primary--text">Ajuste</h3>
                    <v-spacer></v-spacer>
                    Total {{ itemRecibo.moneda + " " + $formatoNumero(itemRecibo.totalAjuste) }}
                  </v-system-bar>

                  <v-divider></v-divider>
                </v-container>
              </v-sheet>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogOmega"
        persistent
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card
              ref="form"
              id="lateral"
              :height="isMobile ? height : height - 100"
            >
              <v-app-bar color="white" elevate-on-scroll flat>
                <div class="headline">Rendición de Recibos</div>

                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      large
                      @click="dialogAlpha = true"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> fa-solid fa-print </v-icon>
                    </v-btn>
                  </template>
                  <span>Imprimir Rendicion</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      large
                      @click="mostrarDialogCarga('Rendicion')"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> fa-solid fa-money-bill-transfer </v-icon>
                    </v-btn>
                  </template>
                  <span>Generar rendición</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeRendicion"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar</span>
                </v-tooltip>
              </v-app-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-list two-line>
                    <v-list-group :value="false">
                      <template v-slot:activator>
                        <v-list-item-title
                          class="primary--text font-weight-bold"
                          >Total a Rendir</v-list-item-title
                        >
                        <v-list-item-action>
                          <v-list-item-action-text :class="'font-weight-bold'">
                            {{ "Bs." + $formatoNumero(total_rendicion) }}
                          </v-list-item-action-text>
                        </v-list-item-action>
                      </template>

                      <v-list-item v-for="item in dtRendicion" :key="item.id">
                        <template v-slot:default="{}">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >{{ item.recibo }}
                            </v-list-item-title>

                            <v-list-item-subtitle class="success--text"
                              >{{ item.tipo }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                              >{{ item.banco }}
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-list-item-action-text
                              :class="'font-weight-bold'"
                            >
                              {{
                                item.moneda + "" + $formatoNumero(item.monto)
                              }}
                            </v-list-item-action-text>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                  <v-divider></v-divider>

                  <v-list two-line>
                    <v-list-group :value="false">
                      <template v-slot:activator>
                        <v-list-item-title
                          class="primary--text font-weight-bold"
                          >Total Efectivo</v-list-item-title
                        >
                        <v-list-item-action>
                          <v-list-item-action-text :class="'font-weight-bold'">
                            {{ "Bs." + $formatoNumero(total_efectivo) }}
                          </v-list-item-action-text>
                        </v-list-item-action>
                      </template>

                      <v-list-item v-for="item in dtEfectivo" :key="item.id">
                        <template v-slot:default="{}">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >{{ item.recibo }}
                            </v-list-item-title>

                            <v-list-item-subtitle
                              >{{ item.banco }}
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-list-item-action-text
                              :class="'font-weight-bold'"
                            >
                              {{
                                item.moneda + "" + $formatoNumero(item.monto)
                              }}
                            </v-list-item-action-text>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </v-list-group>
                  </v-list>

                  <v-divider></v-divider>

                  <v-list two-line>
                    <v-list-group :value="true">
                      <template v-slot:activator>
                        <v-list-item-title
                          class="primary--text font-weight-bold"
                          >Total Cheque</v-list-item-title
                        >
                        <v-list-item-action>
                          <v-list-item-action-text :class="'font-weight-bold'">
                            {{ "Bs." + $formatoNumero(total_cheque) }}
                          </v-list-item-action-text>
                        </v-list-item-action>
                      </template>
                      <v-list-item-group
                        v-model="selectedValor"
                        active-class="blue--text"
                      >
                        <v-list-item v-for="item in dtCheque" :key="item.id">
                          <template v-slot:default="{ active }">
                            <v-list-item-avatar
                              v-if="
                                !(
                                  item.foto_comprobante === null ||
                                  item.foto_comprobante === undefined ||
                                  item.foto_comprobante === ''
                                )
                              "
                            >
                              <div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <viewer>
                                      <img
                                        :src="item.foto_comprobante"
                                        class="image"
                                        v-bind="attrs"
                                        v-on="on"
                                      />
                                    </viewer>
                                  </template>
                                  <span>{{
                                    item.foto_comprobante === null ||
                                    item.foto_comprobante === undefined ||
                                    item.foto_comprobante === ""
                                      ? "nada"
                                      : "Ver depósito dell valor"
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >{{ item.recibo }}
                              </v-list-item-title>

                              <v-list-item-subtitle
                                >{{ item.valor }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                >{{ item.banco }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                :class="'font-weight-bold'"
                              >
                                {{
                                  item.moneda + "" + $formatoNumero(item.monto)
                                }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                            <v-list-item-avatar
                              v-if="
                                !(
                                  item.foto_deposito === null ||
                                  item.foto_deposito === undefined ||
                                  item.foto_deposito === ''
                                ) && !active
                              "
                            >
                              <div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <viewer>
                                      <img
                                        :src="item.foto_deposito"
                                        class="image"
                                        v-bind="attrs"
                                        v-on="on"
                                      />
                                    </viewer>
                                  </template>
                                  <span>{{
                                    item.foto_deposito === null ||
                                    item.foto_deposito === undefined ||
                                    item.foto_deposito === ""
                                      ? "nada"
                                      : "Ver depósito dell valor"
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-avatar>
                            <v-list-item-avatar v-if="active">
                              <v-btn
                                class="mx-2"
                                fab
                                dark
                                small
                                color="secondary"
                                @click="mostrarDialogCarga('Cheque', item)"
                              >
                                <v-icon dark> fa-solid fa-upload </v-icon>
                              </v-btn>
                            </v-list-item-avatar>
                          </template>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list-group>
                  </v-list>

                  <v-divider></v-divider>

                  <v-list two-line>
                    <v-list-group :value="false">
                      <template v-slot:activator>
                        <v-list-item-title
                          class="primary--text font-weight-bold"
                          >Total Transferencia</v-list-item-title
                        >
                        <v-list-item-action>
                          <v-list-item-action-text :class="'font-weight-bold'">
                            {{ "Bs." + $formatoNumero(total_transferencia) }}
                          </v-list-item-action-text>
                        </v-list-item-action>
                      </template>
                      <v-list-item-group
                        v-model="selectedValor"
                        active-class="blue--text"
                      >
                        <v-list-item
                          v-for="item in dtTransferencia"
                          :key="item.id"
                        >
                          <template v-slot:default="{}">
                            <v-list-item-avatar
                              v-if="
                                !(
                                  item.foto_comprobante === null ||
                                  item.foto_comprobante === undefined ||
                                  item.foto_comprobante === ''
                                )
                              "
                            >
                              <div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <viewer>
                                      <img
                                        :src="item.foto_comprobante"
                                        class="image"
                                        v-bind="attrs"
                                        v-on="on"
                                      />
                                    </viewer>
                                  </template>
                                  <span>{{
                                    item.foto_comprobante === null ||
                                    item.foto_comprobante === undefined ||
                                    item.foto_comprobante === ""
                                      ? "nada"
                                      : "Ver depósito dell valor"
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >{{ item.recibo }}
                              </v-list-item-title>

                              <v-list-item-subtitle
                                >{{ item.valor }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                >{{ item.banco }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                :class="'font-weight-bold'"
                              >
                                {{
                                  item.moneda + "" + $formatoNumero(item.monto)
                                }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list-group>
                  </v-list>

                  <v-divider></v-divider>
                </v-container>
              </v-sheet>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog dense v-model="dialogGamma" persistent max-width="500px">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga de Foto</span>
            </v-card-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="dialogGamma = false"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>
          <v-card-subtitle v-if="tipoCarga === 'Rendicion'">
            {{
              "Para generar la rendición debe adjuntar una foto del comprobante de depósito de Bs. " +
              $formatoNumero(total_efectivo) +
              " en el banco."
            }}
          </v-card-subtitle>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    dense
                    id="fileValor"
                    ref="fileValor"
                    v-model="fileValor"
                    @change="archivoCambiadoImagen"
                    counter
                    :rules="[$rules.requeridoArchivo]"
                    show-size
                    chips
                    accept="image/*"
                    prepend-icon="camera_alt"
                    placeholder="Seleccione una imagen"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click.prevent="
                    tipoCarga === 'Recibo'
                      ? saveRecibo()
                      : tipoCarga === 'Cheque'
                      ? saveCheque()
                      : generarRendicion('C')
                  "
                  color="success"
                  :loading="loadRecibo"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar Imagen</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAlpha" persistent max-width="390">
        <v-card>
          <v-card-title>Impresión de detalle de Rendición</v-card-title>
          <v-card-text
            >Seleccione el banco donde realizará el depósito:

            <v-autocomplete
              dense
              outlined
              ref="bancoDeposito"
              v-model="bancoDeposito"
              :items="itemsBanco"
              :rules="[$rules.requerido]"
              :error-messages="errorMessagesRecibo"
              @change="mostrarDescripcionBanco"
              item-text="descripcion"
              item-value="id"
              label="Banco"
              required
              hide-details
            >
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAlpha = false">Cancelar</v-btn>

            <div>
              <v-btn color="primary" text @click="generarPDF()">Imprimir</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<style>
/* This is for documentation purposes and will not be needed in your application */
.floating-button {
  bottom: 0;
  right: 0;
  width: 90%;
  position: absolute;
  margin: 16px 16px 16px 16px;
}
</style>
<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import QRCode from "qrcodejs2";

export default {
  mixins: [dialogMixin],
  data() {
    return {
      //variables globales
      usuario: this.$store.state.usuario.user,
      nombreUsuario: this.$store.state.usuario.nombre,
      idUsuario: this.$store.state.usuario.id,

      formReciboEditado: false,
      idRecibo: 0,
      idCheque: 0,      //Varibles Cliente - refactorizadas para usar itemRecibo
      // cliente_codigo: "",
      // cliente_descripcion: "",
      // numero_recibo: "",
      // fecha: "",
      cliente_id: "",
      showSearchRecibo: false,
      typeSearchRecibo: true,
      awaitingSearchCliente: false,
      searchCodRecibo: "",
      countCharCliente: 0,
      dtRecibo: [],
      loadRecibo: false,
      loadRendicion: false,
      loadButton: false,
      selectedCliente: [],
      fileValor: null,

      itemsBanco: [],
      bancoDeposito: "",
      cuentaDeposito: "",
      descripcionBanco: "",

      //Variables de formato global
      width: 0,
      height: 0,
      isMobile: false,
      tipoCarga: "",
      //Variables de Recibo

      formReciboDescripcion: "",

      dialogBeta: false,
      showSearchRecibo: false,
      searchRecibo: "",
      selectedRecibo: [],
      itemRecibo: {},

      fechaActual: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      errorMessagesRecibo: "",
      errorMessagesForm: "",

      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      showFechaValor: false,
      showRecibo: false,
      valida: 0,

      valorTipoId: 0,
      valorTipoDescripcion: "",
      valorTipoTipo: "",

      importeValor: 0,
      cantidadValor: 0,
      detailValor: "Sin valores seleccionados",

      dialogMu: false,

      //variables de documento
      selectedDocumento: [],
      selectedRendicion: [],
      selectedValor: [],
      dtDocumento: [],
      dtRendicion: [],
      dtEfectivo: [],
      dtCheque: [],
      dtTransferencia: [],
      dtValor: [],

      admins: [
        ["Management", "save"],
        ["Settings", "edit"],
      ],
      cruds: [
        ["Create", "save"],
        ["Read", "save"],
        ["Update", "save"],
        ["Delete", "save"],
      ],      // Variables de totales - refactorizadas para usar itemRecibo
      // total_documento: 0,
      // total_valor: 0,
      // totalAjuste: 0,

      total_efectivo: 0,
      total_cheque: 0,
      total_transferencia: 0,
      total_rendicion: 0,

      // moneda: "Bs.", // Ahora usar itemRecibo.moneda

      // foto_recibo: "", // Ahora usar itemRecibo.fotoRecibo
      // foto_efectivo: "", // Ahora usar itemRecibo.fotoEfectivo
      // estado_recibo: "", // Ahora usar itemRecibo.estado

      modalFechaInicial: false,
      fechaInicial: "",
    };
  },

  watch: {
    typeSearchRecibo: function (val) {
      this.countCharCliente = this.searchCodRecibo.length;

      if (this.countCharCliente > 2) {
        this.loadRecibo = true;
        this.listarCliente();
      }
    },

    searchCodRecibo: function (val) {
      if (!this.awaitingSearchCliente) {
        setTimeout(() => {
          this.countCharCliente = this.searchCodRecibo.length;

          if (this.countCharCliente > 2) {
            this.loadRecibo = true;
            this.listarCliente();
          }
          this.awaitingSearchCliente = false;
        }, 1500); // 1 sec delay
      }
      this.awaitingSearchCliente = true;
    },
  },

  mounted() {
    this.getDimensions();
  },

  created() {
    this.$store.dispatch("actualizarTitulo", "Recibos");

    this.selectBancos();
    //configuramos fechaInicial para que sea de 7 días atrás

    this.fechaInicial = this.$formatoFecha(
      new Date(new Date().setDate(new Date().getDate() - 7))
    );
    this.listarRecibo();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  computed: {
    filtrarDtRecibo() {
      return _.orderBy(
        this.dtRecibo.filter((item) => {
          // Filtrar por numero_recibo dentro del objeto recibos
          if (!this.searchRecibo) return true; // Mostrar todos si no hay filtro

          // Función auxiliar para verificar si un recibo contiene el numero_recibo buscado
          const reciboMatchesSearch = (recibo) => {
            return (
              (recibo.numero_recibo || "")
                .toLowerCase()
                .includes(this.searchRecibo.toLowerCase()) ||
              (recibo.cliente_descripcion || "")
                .toLowerCase()
                .includes(this.searchRecibo.toLowerCase())
            );
          };

          // Filtrar por numero_recibo en los objetos recibos de cada item
          return item.recibos.some((recibo) => reciboMatchesSearch(recibo));
        }),
        "headline"
      );
    },

    formRecibo() {
      return {
        formReciboDescripcion: this.formReciboDescripcion,
      };
    },
  },
  methods: {
    cancelFechaInicial() {
      let me = this;
      me.modalFechaInicial = false;
    },

    setFechaInicial() {
      let me = this;
      me.listarRecibo();
      me.modalFechaInicial = false;
    },
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },

    listarRecibo() {
      let me = this;
      me.loadRecibo = true;
      axios
        .get("api/recibos/ListarPorFecha", {
          params: {
            // Los parámetros deben ir aquí
            fecha: me.fechaInicial,
            usuario: me.usuario,
          },
        })
        .then(function (response) {
          me.dtRecibo = response.data.items;
          console.log("rendiciones ",me.dtRecibo);

          me.loadRecibo = false;
        })
        .catch(function (error) {
          me.loadRecibo = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarRendicion() {
      let me = this;
      me.dtCheque = [];
      me.dtEfectivo = [];
      me.dtTransferencia = [];
      me.loadButton = true;

      axios
        .get("api/rendiciones/listarRendicionPreliminar" + "/" + me.usuario)
        .then(function (response) {
          me.dtRendicion = response.data;
          console.log("dtRendicion ", me.dtRendicion);
          if (me.dtRendicion.length > 0) {
            me.dialogOmega = true;
          } else {
            me.$store.dispatch("setSnackbar", {
              text: "No hay recibos pendientes de rendición.",
              color: "error",
            });
          }

          me.dtRendicion.forEach((element) => {
            if (element.tipo == "Cheque") {
              me.dtCheque.push(element);
            }
            if (element.tipo == "Efectivo") {
              me.dtEfectivo.push(element);
            }
            if (element.tipo == "Transferencia Bancaria") {
              me.dtTransferencia.push(element);
            }
          });

          me.total_efectivo = me.dtRendicion.reduce((tot, obj) => {
            if (obj.tipo == "Efectivo") {
              return tot + obj.monto;
            }
            return tot;
          }, 0);
          me.total_cheque = me.dtRendicion.reduce((tot, obj) => {
            if (obj.tipo == "Cheque") {
              return tot + obj.monto;
            }
            return tot;
          }, 0);
          me.total_transferencia = me.dtRendicion.reduce((tot, obj) => {
            if (obj.tipo == "Transferencia Bancaria") {
              return tot + obj.monto;
            }
            return tot;
          }, 0);
          me.total_rendicion = me.dtRendicion.reduce((tot, obj) => {
            return tot + obj.monto;
          }, 0);
          me.loadButton = false;
        })
        .catch(function (error) {
          me.loadButton = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    cleanRecibo() {
      this.formReciboDescripcion = "";
      this.formReciboEditado = false;
      this.selectedFile = null;
      this.fileValor = null;
      this.file;
    },

    closeRecibo() {
      this.dialogBeta = false;

      this.cleanRecibo();
    },
    cleanRendicion() {
      this.total_efectivo = 0;
      this.total_cheque = 0;
      this.total_transferencia = 0;
      this.total_rendicion = 0;
      this.dtRendicion = [];
      this.selectedFile = null;
      this.fileValor = null;
    },
    closeRendicion() {
      this.dialogOmega = false;

      this.cleanRendicion();
    },    editRecibo(item) {
      this.idRecibo = item.id;
      console.log("editando recibo ", item);  
      this.dtDocumento = item.documentos;
      this.dtValor = item.valores;
      this.itemRecibo = item;
      //this.obtenerDetallesRecibo(item);

      this.formReciboDescripcion = item.descripcion;
      this.formReciboEditado = true;
      
      // Variables refactorizadas - ahora usar itemRecibo directamente
      // this.cliente_descripcion = item.clienteDescripcion;
      // this.cliente_codigo = item.clienteCodigo;
      // this.numero_recibo = item.numeroRecibo;
      // this.fecha = item.fecha;
      // this.totalAjuste = item.totalAjuste;
      // this.total_documento = item.totalDocumento;
      // this.total_valor = item.totalValor;
      // this.foto_recibo = item.fotoRecibo;
      // this.foto_efectivo = item.fotoEfectivo;
      // this.estado_recibo = item.estado;
      // this.moneda = item.moneda;

      this.dialogBeta = true;
    },
    mostrarRendicion() {
      this.listarRendicion();
    },

    async mostrarDialogCarga(tipo, item) {
      // Esperamos a que validarTransferencias se resuelva antes de continuar
      var clienteList = await this.validarTransferencias();

      if (tipo === "Rendicion") {
        if (clienteList.length > 0) {
          var mensajeError =
            "No se puede generar la rendición, existen transferencias pendientes de comprobación. \n";
          clienteList.forEach((element) => {
            mensajeError +=
              "Pago de " +
              element.monto +
              " Bs. del " +
              element.banco +
              " para el cliente: (" +
              element.codigo_cliente +
              ")" +
              element.cliente +
              " | \n";
          });

          this.$store.dispatch("setSnackbar", {
            text: mensajeError,
            color: "error",
          });
          return;
        }

        if (this.total_efectivo === 0) {
          this.generarRendicion("S"); // La variable "S" significa sin fotografía
        }
      } else {
        if (item != undefined) {
          this.idCheque = item.id_valor_documento;
        }
      }
      this.tipoCarga = tipo;
      this.dialogGamma = true;
    },

    //creamos un metodo asincrono para validar si existen transferencias pendientes de comprobación

    async validarTransferencias() {
      let me = this;
      var respuesta = [];

      try {
        const response = await axios.get(
          "api/valor_documentos/validarTransferencias/" + me.usuario
        );
        respuesta = response.data;
      } catch (error) {
        me.$store.dispatch("setSnackbar", {
          text:
            error == "Error: Network Error"
              ? "No se pudo conectar con el servidor"
              : error,
          color: "error",
        });
      }

      return respuesta; // Devuelve la respuesta una vez que se haya llenado
    },

    addRecibo() {
      this.formReciboDescripcion = "";
      this.formReciboEditado = false;
      this.dialogBeta = true;
    },

    saveRecibo() {
      let me = this;

      const formData = new FormData();
      formData.append("id", this.idRecibo);
      formData.append("usuario", this.usuario);
      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }
      me.loadRecibo = true;
      axios
        .put("api/recibos/SubirImagen", formData)        .then(function (response) {
          me.loadRecibo = false;
          me.itemRecibo.fotoRecibo = response.data;
          me.closeRecibo();
          me.listarRecibo();
          me.generarRendicionTransferencia();
          me.$store.dispatch("setSnackbar", {
            text: "Imagen cargada exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    saveCheque() {
      let me = this;

      const formData = new FormData();
      formData.append("id", this.idCheque);
      formData.append("usuario", this.usuario);
      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }
      me.loadRecibo = true;
      axios
        .put("api/valor_documentos/SubirDeposito", formData)
        .then(function (response) {
          me.loadRecibo = false;
          me.foto_deposito = response.data;
          me.listarRendicion();
          me.listarRecibo();
          me.cleanRecibo();
          me.dialogGamma = false;

          me.$store.dispatch("setSnackbar", {
            text: "Comprobante de cheque cargado exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    generarRendicion(origen) {
      // la variable "C" significa con fotografia y "S" significa sin fotografía
      let me = this;

      const formData = new FormData();

      formData.append("usuario", this.usuario);
      if (this.selectedFile === null && origen === "C") {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      } else {
        formData.append("subido", this.selectedFile);
      }
      me.loadRecibo = true;
      axios
        .put("api/rendiciones/GenerarRendicion", formData)
        .then(function (response) {
          me.loadRecibo = false;
          me.listarRecibo();
          me.closeRendicion();
          me.dialogGamma = false;

          me.$store.dispatch("setSnackbar", {
            text: "Rendicion generada exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.loadRecibo = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    generarRendicionTransferencia() {
      // la variable "C" significa con fotografia y "S" significa sin fotografía
      let me = this;
      me.loadRecibo = true;
      axios
        .put(
          "api/rendiciones/GenerarRendicionTransferencia/" +
            this.idRecibo +
            "/" +
            this.usuario,
          {}
        )
        .then(function (response) {
          me.loadRecibo = false;
          me.listarRecibo();
          me.closeRendicion();
          me.dialogGamma = false;

          me.$store.dispatch("setSnackbar", {
            text: "Rendicion generada exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.loadRecibo = false;
          console.error(error.response.data);
        });
    },

    obtenerDetallesRecibo(item) {
      let me = this;

      me.numero_recibo = item.numero_recibo;

      axios
        .get("api/valor_documentos/ListarPorRecibo/" + item.id)
        .then(function (response) {
          me.dtValor = response.data;
          axios
            .get("api/documentos/ListarPorRecibo/" + item.id)
            .then(function (response) {
              me.dtDocumento = response.data;
            })
            .catch(function (error) {
              me.$store.dispatch("setSnackbar", {
                text:
                  error == "Error: Network Error"
                    ? "No se pudo conectar con el servidor"
                    : error,
                color: "error",
              });
            });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    redondear(num) {
      var res = 0;
      if (num < 0.000001 && num > -0.000001) res = 0;
      else res = +(Math.round(num + "e+2") + "e-2");

      return res;
    },
    formatoNumero(num) {
      return num.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    quitarformatoNumero(num) {
      return num.replace(/,/g, "");
    },

    estaVencido(fecha) {
      var fechaActual = new Date();
      var fechaVencimiento = new Date(fecha);
      if (fechaActual > fechaVencimiento) {
        return true;
      } else {
        return false;
      }
    },

    archivoCambiadoImagen(e) {
      this.selectedFile = e;
      if (e != null) {
        this.foto = URL.createObjectURL(this.selectedFile);
      } else {
        this.foto = "/uploads/student.png";
      }
    },

    selectBancos() {
      let me = this;
      axios
        .get("api/bancos/select/T")
        .then(function (response) {
          me.itemsBanco = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    mostrarDescripcionBanco() {
      var me = this;
      axios
        .get("/api/bancos/descripcionCuentaBanco/" + me.bancoDeposito)
        .then(function (response) {
          var a = response.data.split("|");
          me.descripcionBanco = a[0];
          me.cuentaDeposito = a[1];
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    validarRecibo() {
      this.valida = 0;

      Object.keys(this.formRecibo).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    generarPDF() {
      if (this.$esNulo(this.bancoDeposito)) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un banco",
          color: "error",
        });
        return;
      }

      var mensajeEntorno =
        this.$ENTORNO == "P"
          ? "MEGALABS BOLIVIA SRL"
          : "ESTE ES UN DOCUMENTO DE PRUEBA";

      var aux = 0;
      var filasValor = 0;
      var filasDocumento = 0;
      this.dialogAlpha = false;

      var fechaAct = this.$formatoFechaHoras(new Date(Date.now()));

      //generación del documento
      var paperHeight = 60;
      const doc = new jsPDF("l", "mm", [paperHeight, 80]);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);

      doc.text("Rendición " + fechaAct, 40, 10, null, null, "center");

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");

      doc.text("Total a Rendir: ", 5, 20);
      doc.setFont("helvetica", "normal");
      doc.text(
         "Bs. " + this.$formatoNumero(this.total_rendicion),
        75,
        20,
        null,
        null,
        "right"
      );

      doc.text("Total Cheque: ", 5, 25);
      doc.setFont("helvetica", "normal");
      doc.text(
        "Bs. " + this.$formatoNumero(this.total_cheque),
        75,
        25,
        null,
        null,
        "right"
      );

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Total Efectivo: ", 5, 30);
      doc.setFont("helvetica", "normal");
      doc.text(
         "Bs. " + this.$formatoNumero(this.total_efectivo),
        75,
        30,
        null,
        null,
        "right"
      );

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Cuenta a Depositar: ", 5, 45);
      doc.setFont("helvetica", "normal");
      doc.text(this.descripcionBanco, 40, 50, null, null, "center");
      doc.setFontSize(10);

      doc.setFont("helvetica", "normal");
      doc.text(this.cuentaDeposito, 40, 55, null, null, "center");

      //generamos el documento pdf
      doc.save("Detalle de depósitos " + fechaAct + ".pdf");
    },

    generarReciboPDF() {
      var filasDocumento = this.dtDocumento.length * 4.65;
      var filasValor = this.dtValor.length * 4.65;
      var fechaAct = this.$formatoFechaHoras(this.itemRecibo.fecha);
      var numeroLiteral;
      var monedaSingular = "Boliviano";
      var monedaPlural = "Bolivianos";
      var centavos = "/100";
      var mensajeEntorno =
        this.$ENTORNO == "P"
          ? "MEGALABS BOLIVIA SRL"
          : "DOCUMENTO DE PRUEBA";

      numeroLiteral = this.$numerosALetras(
        this.itemRecibo.totalDocumento,

        monedaSingular,
        monedaPlural,
        centavos
      );

      var colValor = ["Medio de Pago", "Importe"];
      var colDocumento = ["Nro Comp", "Subtotal", "Saldo"];

      var rowsValor = [];
      var rowValor = [];
      var rowsDocumento = [];
      var rowDocumento = [];

      var arrValor = this.dtValor;
      var mensajeCheque = "";
      var esCheque = false;
      
      arrValor.forEach((obj) => {
        let rowValor = [];

        const {
          codigo,
          valor,
          idTipoValor,
          monto,
          bancoDestino,
          cuentaDestino,
          fechaDeposito,
        } = obj;
        console.log("objeto",obj);
        let descripcion =
          valor;

        if (idTipoValor == "3") {
          mensajeCheque = "Cobranza sujeta a acreditación de cheque.";
          filasValor += 16.65;
          esCheque = true;

          // Agregar información extra con saltos de línea
          descripcion += `\nBanco a Depositar: `;
          descripcion += `\n${bancoDestino || "N/A"} (${
            cuentaDestino || "N/A"
          })`;
          descripcion += `\nFecha a Depositar: `;
          descripcion += `\n${
            this.$formatoFechaSpanish(fechaDeposito) || "N/A"
          }`;
        }

        if (descripcion) {
          rowValor.push(descripcion);
        }

        if (monto !== undefined) {
          rowValor.push(this.$formatoNumero(monto));
        }

        rowsValor.push(rowValor);
      });

      var arrDocumento = this.dtDocumento;
      
      var subtotal = 0;
      arrDocumento.forEach((obj) => {
        let rowDocumento = [];

        const { codigo, subtotal: sub, saldo } = obj;

        if (codigo !== undefined) {
          rowDocumento.push(codigo);
        }

        if (sub !== undefined) {
          rowDocumento.push(this.$formatoNumero(sub));
          subtotal = sub; // Actualiza el subtotal
        }

        if (saldo !== undefined) {
          rowDocumento.push(this.$formatoNumero(saldo - subtotal));
        }

        rowsDocumento.push(rowDocumento);
      });
      //generación del documento
      var paperHeight = 200 + filasDocumento + filasValor;
      const doc = new jsPDF("p", "mm", [paperHeight, 80]);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);

      doc.text(mensajeEntorno, 40, 10, null, null, "center");

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("RECIBO N°" + this.itemRecibo.numeroRecibo, 40, 20, null, null, "center");

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text("Fecha: " + fechaAct, 5, 25);

      doc.text("Cobrador:  " + this.nombreUsuario, 5, 30);      doc.text(
        "Cliente: (" + this.itemRecibo.clienteCodigo + ")" + this.itemRecibo.clienteDescripcion,
        5,
        35
      );
      
      doc.line(5, 45, 75, 45);
      doc.line(5, 50, 75, 50);
      autoTable(doc, {
        head: [colDocumento],
        body: rowsDocumento,
        startY: 45,
        margin: 5,
        theme: "plain",

        styles: { cellPadding: 0.5, fontSize: 9, lineWidth: 0.0 },
        columnStyles: {
          0: { cellWidth: 30 },
          2: { cellWidth: 20, halign: "right" },
          3: { cellWidth: 20, halign: "right" },
        },
      });
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.line(5, 50 + filasDocumento, 75, 50 + filasDocumento);
      doc.text("Total Documentos: ", 5, 55 + filasDocumento);      doc.text(
        this.$formatoNumero(this.itemRecibo.totalDocumento),

        75,
        55 + filasDocumento,
        null,
        null,
        "right"
      );

      doc.line(5, 70 + filasDocumento, 75, 70 + filasDocumento);
      doc.line(5, 75 + filasDocumento, 75, 75 + filasDocumento);
      autoTable(doc, {
        head: [colValor],
        body: rowsValor,
        margin: 5,
        startY: 70 + filasDocumento,
        theme: "plain",

        styles: { cellPadding: 0.5, fontSize: 9, lineWidth: 0.0 },
        columnStyles: {
          0: { cellWidth: 50 },
          1: { cellWidth: 20, halign: "right" },
        },
      });
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.line(
        5,
        75 + filasValor + filasDocumento,
        75,
        75 + filasValor + filasDocumento
      );
      doc.text("Ajuste: ", 5, 80 + filasValor + filasDocumento);
      doc.text(
        this.$formatoNumero(this.itemRecibo.totalAjuste),
        75,
        80 + filasValor + filasDocumento,
        null,
        null,
        "right"
      );
      doc.text("Total Recibido: ", 5, 85 + filasValor + filasDocumento);
      doc.text(
        this.$formatoNumero(this.itemRecibo.totalValor),
        75,
        85 + filasValor + filasDocumento,
        null,
        null,
        "right"
      );
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");

      doc.text("Son: " + numeroLiteral, 5, 95 + filasValor + filasDocumento, {
        align: "justify",
        lineHeightFactor: 1.5,
        maxWidth: 70,
      });
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text(
        "Firma del Cliente",
        40,
        120 + filasValor + filasDocumento,
        null,
        null,
        "center"
      );
      doc.setFontSize(8);
      doc.text(
        mensajeCheque,
        40,
        123 + filasValor + filasDocumento,
        null,
        null,
        "center"
      );

      doc.text(
        "Fecha: " + fechaAct,
        40,
        128 + filasValor + filasDocumento,
        null,
        null,
        "center"
      );
      doc.text(
        "Cobrador:  " + this.nombreUsuario,
        40,
        133 + filasValor + filasDocumento,
        null,
        null,
        "center"
      );
      doc.text(
        "Cliente: (" + this.itemRecibo.clienteCodigo + ")" + this.itemRecibo.clienteDescripcion,
        40,
        138 + filasValor + filasDocumento,
        null,
        null,
        "center"
      );

      //generaci+on del codigo qr
      var canvasDiv = document.createElement("div"); //New dom element, if there is only one page, you can use the page element directly

      canvasDiv.id = "canvas";

      this.$refs.qrCodeUrl.append(canvasDiv);      var qrcode = new QRCode("canvas", {
        //qrcode generates QR code
        text:
          this.itemRecibo.clienteCodigo +
          "|" +
          this.itemRecibo.clienteDescripcion +
          "|" +
          this.itemRecibo.numeroRecibo +
          "|" +
          this.nombreUsuario +
          "|" +
          fechaAct +
          "|" +
          this.$formatoNumero(this.itemRecibo.totalValor) +
          "|" +
          this.$formatoNumero(this.itemRecibo.totalDocumento) +
          "|" +
          this.$formatoNumero(this.itemRecibo.totalAjuste),

        width: 80,
        height: 80,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.M,
      });

      let canvas = document.getElementById("canvas").querySelector("canvas"); //Get the canvas element

      var dataURL = canvas.toDataURL();

      canvas = null;

      doc.setFontSize(12);

      doc.addImage(
        dataURL,
        "JPEG",
        15,
        140 + filasValor + filasDocumento,
        50,
        50
      );      //generamos el documento pdf
      doc.save("Recibo N° " + this.itemRecibo.numeroRecibo + ".pdf");
    },
  },
};
</script>
